import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Label from "components/Label"
import { useLocale } from "context/locale"
import eco_product_image from "images/refresh/eco_product-refresh-v3.svg"
import second_life_image_v2 from "images/refresh/second_life_v2-refresh-v4.svg"
import StyledChangeDirection from "./styles.js"

const ChangeDirection = () => {
  const { t } = useLocale()
  const data = useStaticQuery(
    graphql`
      query {
        background_image: file(
          relativePath: { eq: "refresh/1920x549_DWA_KIERUNKI_ZMIAN.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        background_image_mobile: file(
          relativePath: { eq: "refresh/1920x549_DWA_KIERUNKI_ZMIAN.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1100) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `
  )

  const background_source = [
    data.background_image_mobile.childImageSharp.fluid,
    {
      ...data.background_image.childImageSharp.fluid,
      media: `(min-width: 1101px)`,
    },
  ]

  return (
    <StyledChangeDirection>
      <BackgroundImage
        fluid={background_source}
        backgroundColor={`#fff`}
        style={{ backgroundPosition: "top center" }}
      >
        <div className="change-direction__container">
          <div className="main-container">
            <div className="change-direction__header">
              <Label text="#product" />
              <h2 className="title h1">{t("Two directions for change")}</h2>
            </div>
            <div className="change-direction__wrapper">
              <div className="change-direction-box eco">
                <div className="text-holder">
                  <p className="title bolder">{t("New products")}</p>
                  <p className="desc">
                    {/* {t(
                      "Designed and produced in accordance with the 4F Change strategy"
                    )} */}
                    Zawierają materiały, potwierdzone certyfikatami niezależnych
                    instytucji certyfikujących lub licencjami. Szczegółowy skład
                    ubrań i akcesoriów umieszczamy na zawieszkach i na kartach
                    produktów w sklepie internetowym.
                  </p>
                </div>

                <div className="image-holder">
                  <img src={eco_product_image} alt="Eco product" />
                </div>
              </div>
              <div className="change-direction-box second_life">
                <div className="text-holder">
                  <p className="title bolder">{t("Second life")}</p>
                  <p className="desc">
                    {t("We extend the lifespan of already existing clothes")}
                  </p>
                </div>
                <div className="image-holder">
                  <img src={second_life_image_v2} alt="Second life" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </BackgroundImage>
    </StyledChangeDirection>
  )
}

export default ChangeDirection
